export const NOTIFICACAO_FETCH_COUNT = 'NOTIFICACAO_FETCH_COUNT';
export const NOTIFICACAO_FETCH_COUNT_SUCCESS = 'NOTIFICACAO_FETCH_COUNT_SUCCESS';
export const NOTIFICACAO_FETCH_PREVIEW = 'NOTIFICACAO_FETCH_PREVIEW';
export const NOTIFICACAO_FETCH_PREVIEW_SUCCESS = 'NOTIFICACAO_FETCH_PREVIEW_SUCCESS';
export const NOTIFICACAO_MARK_READ = 'NOTIFICACAO_MARK_READ';
export const NOTIFICACAO_MARK_READ_SUCCESS = 'NOTIFICACAO_MARK_READ_SUCCESS';
export const NOTIFICACAO_MARK_ALL_READ = 'NOTIFICACAO_MARK_ALL_READ';
export const NOTIFICACAO_MARK_ALL_READ_SUCCESS = 'NOTIFICACAO_MARK_ALL_READ_SUCCESS';
export const NOTIFICACAO_LOTE = 'NOTIFICACAO_LOTE';
export const NOTIFICACAO_LOTE_SUCCESS = 'NOTIFICACAO_LOTE_SUCCESS';
export const NOTIFICACAO_CLEAN = 'NOTIFICACAO_CLEAN';
